<template>
  <div class="fullwidth narex collections account">
    <my-area-nav />
    <div class="collection-view ">
      <div class="account-panel">
        <div class="profile-grid">
          <div class="user-image">
            <img :src="userImage" />
          </div>
          <div class="my-profile-title">
            My profile
          </div>
          <div class="labels">Name</div>
          <div>{{ $store.state.profile.fullname}}</div>
          <div class="pf-edit-button">edit</div>

          <div class="labels">Job title</div>
          <div>{{ $store.state.profile.job_title }}</div>
          <div class="pf-edit-button">edit</div>

          <div class="labels">Organisation</div>
          <div>{{ $store.state.profile.company }}</div>
          <div class="pf-edit-button">edit</div>

          <div class="labels">Sector</div>
          <div>{{ $store.state.profile.sector }}</div>
          <div class="pf-edit-button">edit</div>

          <div class="labels">Location</div>
          <div>{{ $store.state.profile.location }}</div>
          <div class="pf-edit-button">edit</div>

          <div class="labels">Email</div>
          <div>{{ $store.state.profile.email }}</div>
          <div class="pf-edit-button">edit</div>

          <div class="labels">Password</div>
          <div><small-button v-on:click="resetPassword">Request Reset</small-button></div>
        </div>
        <div class="account-bar"></div>
        <div>
          <div class="bold">My main areas of interest (optional)</div>
          <div class="interest-checks">
            <div v-for="item in interestChoices" :key="item" class="checky">
              <input type="checkbox" v-model="interests" :value="item" /> {{ item }}
            </div>
          </div>
        </div>
        <div class="account-bar"></div>
        <div class="right">
          <div class="invisi-button" v-on:click="handleDeleteAccount">Delete account</div>
        </div>
      </div>
      <div class="lovely-message">
        <editable-item :page="$route.name" item="text" :loaded="editableLoaded" />
      </div>
    </diV>
  </div>
</template>

<script>
import MyAreaNav from './MyAreaNav.vue'
import EditablePage from '@/mixins/EditablePage.js'
import Auth from '@aws-amplify/auth'
import '@/css/my-area.css'
export default {
  mixins: [EditablePage],
  components: {
    MyAreaNav
  },
  data () {
    return {
      interests: [],
      interestChoices: ['Animals','Animation','Architecture','Children','Educational','Fantasy',
      'Fashion','Food and Drink','Maps','Medical','Nature','People','Portraits','Retro']
    }
  },
  created () {
    if(!this.$store.state.signedIn) {
      this.$ixr.push('/')
    }
    else {
      this.init ()
    }
  },
  methods: {
    async init () {
      if(this.$store.state.profile) {
        const profile = this.$store.state.profile
        if(profile.avatar){
          this.userImage = this.$k.imagebase + 'images/users/' + profile.avatar
          
        }
        else {
          this.userImage = this.$k.imagebase + 'mediastore/img/user-large.svg'
        }
      }
      
    },
    handleDeleteAccount () {
      console.log('delete it')
    },
    async resetPassword () {
      try {
        await Auth.forgotPassword(this.$store.state.profile.username)
        this.$k.messageBox(this.$nippets.changePassword, this.$nippets.myarea.resetEmailSent)
      }
      catch(err) {
        console.log(err)
        this.$k.messageBox(this.$nippets.changePassword, err.message)
        
      }
    }
  },
  watch: {
    '$store.state.signedIn': function () {
      if(!this.$store.state.signedIn) {
        this.$ixr.push('/')
      }
    }
  }
}
</script>

<style>
.collections .account-panel{
  background-color:#e8e8e3;
  border-radius:30px;
  padding:25px;
  width:600px;
}

.account .collection-view{
  display:flex;
}

.user-image{
  overflow:hidden;
  border-radius:50%;
  width:90px;
  height:90px;
}

.user-image img{
  width:100%;
  height:100%;
  object-fit: cover;
}

.my-profile-title{
  font-size:24px;
  font-weight:500;
  grid-column: 2 / 4;
}

.profile-grid{
  display:grid;
  grid-template-columns: calc(20% - 10px) calc(60% - 10px) calc(20% - 10px);
  grid-gap:15px;
  align-items: center;
}

.profile-grid .labels{
  text-align:right;
  color:#8b6f4b;
  font-weight:500;
}

.profile-grid .pf-edit-button{
  text-align:right;
  font-size:15px;
  color:#6d6d64;
  cursor:pointer;
}

.profile-grid .pf-edit-button:hover{
  color:#ce0e2d;
}

.account-bar{
  background-color:#f9f9f9;
  height:2px;
  margin:25px -25px;
}

.interest-checks{
  column-count:3;
  margin-top:16px;
}

.checky{
  padding:8px;
  break-inside: avoid;
}

input[type="checkbox"]{
  border:1px solid #8b6f4b;
  border-radius:3px;
}

.invisi-button{
  text-align:right;
  color:#b5b3a9;
  user-select: none;
  cursor:pointer;
  font-size:19px;
}

.invisi-button:hover{
  color:#ce0e2d;
}

.lovely-message{
  width:30%;
  margin-left:35px;
  line-height:1.5em;
}
</style>